<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Kolekcja Dworska</h3>
    </app-contentpageheader>
    <app-aulic />
    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../../components/common/ContentPageHeader.vue";

import Aulic from "../../components/collections/types/Aulic.vue";
import Footer from "../../components/common/Footer.vue";
export default {
  data() {
    return {
      backgroundImg: require("../../assets/common/wood.jpg")
    };
  },
  components: {
    "app-aulic": Aulic,
    "app-footer": Footer,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
